module.exports = __webpack_public_path__ + "static/media/CTLI_5-315w.fbba3a39.png";